/* global globalThis */

const normalizeApiUrl = (value) => {
  const rawValue = String(value || "").trim();

  if (!rawValue) {
    return "http://localhost:3001/api/v1";
  }

  try {
    const url = new URL(rawValue);

    if (url.hostname === "stage.money-mails.com") {
      url.hostname = "stage-api.money-mails.com";
    } else if (url.hostname === "money-mails.com") {
      url.hostname = "api.money-mails.com";
    }

    url.pathname = url.pathname.replace(/\/+$/, "");
    return url.toString().replace(/\/$/, "");
  } catch (_error) {
    return rawValue.replace(/\/+$/, "");
  }
};

export const baseUrl = normalizeApiUrl(process.env.REACT_APP_API_URL);

const resolveCookieDomain = () => {
  if (process.env.REACT_APP_COOKIE_DOMAIN) {
    return process.env.REACT_APP_COOKIE_DOMAIN;
  }

  if (typeof globalThis === "undefined" || globalThis.window === undefined) {
    return undefined;
  }

  const host = String(globalThis.window.location.hostname || "").toLowerCase();
  if (!host || host === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    return undefined;
  }

  if (host.endsWith("money-mails.com")) {
    return ".money-mails.com";
  }

  // On localhost, set explicit domain so all ports (3000, 8080 etc) share cookies
  if (host === "localhost") {
    return "localhost";
  }
};

export const REACT_APP_COOKIE_DOMAIN = resolveCookieDomain();
export const Bingo_Url =
  process.env.REACT_APP_BINGO_URL || "http://localhost:5000/";
export const REACT_APP_COOKIE_SECURE =
  process.env.REACT_APP_COOKIE_SECURE === "true";
export const Website_url =
  process.env.REACT_APP_WEBSITE_URL || "http://localhost:3002";
export const REACT_APP_GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
export const NT_ID = process.env.REACT_APP_NT_ID || "";
